module.exports = __webpack_public_path__ + "img/sentra0.50adb1fe.jpeg";